import React from 'react';
import {observer} from 'mobx-react';

import {SeeAllFooterWidget} from "../../../core/components/see-all-footer/see-all-footer";
import {WidgetWrapper} from "../../../core/components/misc/widget-wrapper/widget-wrapper";
import {PreviousMeetingsWidgetAsync} from "../../previous-meetings-widget/components/previous-meetings-widget.async";
import {APP} from "../../../core/app/consts";
import {NAVIGATION_TABS} from "../../../modules/navigation-tabs-module/navigation-tabs-module.consts";
import {RecentFormWidgetAsync} from "../../recent-form-widget/components/recent-form-widget.async";

export const H2hWidgetPartialView = observer(({controller, matchupId, gameId, isFullView, onSeeAllClick}) => {
  const {state} = controller;
  const {terms, device, shouldRenderRecentForm, isGameRoute, currentLinkModel, showOdds} = state;
  const {WEB_GC_HEAD_TO_HEAD, SEE_ALL} = terms;
  const {isRtl} = device;

  const cardProps = {
    controller,
    title: WEB_GC_HEAD_TO_HEAD
  };

  const seeAllByContextProps = {
    routeProps: {tabIndex: NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.h2h},
    isRtl,
    buttonLabel: SEE_ALL,
    source: APP.ANALYTICS.SOURCES.h2h,
    shouldSendAnalyticsEvent: true,
    currentLinkModel,
    controller,
    onClick: () => {
      onSeeAllClick && onSeeAllClick(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.h2h);

      return isGameRoute;
    }
  };

  const recentFormProps = {
    matchupId,
    gameId,
    isFullView,
    controller,
    showOdds
  }

  const previousMeetingProps = {
    matchupId,
    gameId,
    isFullView,
    showOdds,

  }
  return (
    <WidgetWrapper {...cardProps}>
      <PreviousMeetingsWidgetAsync {...previousMeetingProps}/>
      {
        shouldRenderRecentForm ? <RecentFormWidgetAsync {...recentFormProps}/> : null
      }
      <SeeAllFooterWidget {...seeAllByContextProps}/>
    </WidgetWrapper>
  )
});
